<div class="layout-footer">
  <div class="footer-logo-container">
    <img [src]="'assets/baywarelusy/images/Logo_BayWar-re_B_RGB.svg'" alt="atlantis-layout" id="footer-logo">
    <span class="app-name">{{'longname' | env}}</span>
  </div>
  <span class="copyright">&#169; {{'organization' | env}}</span>
</div>
